// Mock data for Hamilton's Smog website

export const businessInfo = {
  name: "Hamilton's Star Smog Check",
  shortName: "Hamilton's Smog",
  tagline: "Marin County's Fastest STAR-Certified Smog Check Station",
  address: "1032 First St, Novato, CA 94945",
  city: "Novato",
  state: "CA",
  zip: "94945",
  phone: "(415) 493-8801",
  phoneRaw: "+14154938801",
  textPhone: "(415) 378-3252",
  textPhoneRaw: "+14153783252",
  email: "info@hamiltonsmogcheck.com",
  bookingUrl: "https://hamiltonsmog.setmore.com",
  directionsUrl: "https://www.google.com/maps/place/1032+1st+St,+Novato,+CA+94945",
  reviewUrl: "https://g.page/r/CfwrE5omJKz2EAE/review",
  yelpUrl: "https://www.yelp.com/biz/hamiltons-smog-novato",
  hours: [
    { day: "Monday", time: "8:30 AM – 5:30 PM" },
    { day: "Tuesday", time: "8:30 AM – 5:30 PM" },
    { day: "Wednesday", time: "8:30 AM – 5:30 PM" },
    { day: "Thursday", time: "8:30 AM – 5:30 PM" },
    { day: "Friday", time: "8:30 AM – 5:30 PM" },
    { day: "Saturday", time: "9:00 AM – 3:00 PM" },
    { day: "Sunday", time: "Closed" }
  ]
};

export const specials = [
  {
    title: "$7 Off Any Smog Check",
    description: "Show this page or mention it at checkout to save $7 on any smog inspection.",
    icon: "BadgeDollarSign"
  },
  {
    title: "Price Match Guarantee",
    description: "Found a lower price nearby? We'll match it. Simple, honest, and fair.",
    icon: "Handshake"
  },
  {
    title: "Free Retest (2000+ Vehicles)",
    description: "If your vehicle fails, come back within 30 days for a free retest.",
    icon: "RefreshCcw"
  },
  {
    title: "Veteran & Senior Recognition",
    description: "Thank you for your service. Ask about our veteran and senior discount when you arrive.",
    icon: "Award"
  }
];

export const services = [
  {
    title: "STAR Smog Certification",
    description: "Full STAR-certified inspections that meet all California DMV registration renewal requirements.",
    icon: "ShieldCheck",
    time: "~20 min"
  },
  {
    title: "Gasoline Vehicles",
    description: "Fast smog checks for all gas-powered cars, trucks, and SUVs — 1976 to present.",
    icon: "Car",
    time: "20–40 min"
  },
  {
    title: "Diesel & Heavy-Duty",
    description: "CARB periodic testing for diesel vehicles over 14,000 GVWR (2013 and newer).",
    icon: "Truck",
    time: "By appt."
  },
  {
    title: "Hybrid Vehicles",
    description: "Certified smog inspections for Toyota, Honda, Ford, Lexus and every major hybrid.",
    icon: "Leaf",
    time: "~20 min"
  },
  {
    title: "Classic Cars (1976–1995)",
    description: "Fully operational DYNO lane for classic vehicles, with discounted re-tests.",
    icon: "CarFront",
    time: "35–40 min"
  },
  {
    title: "Motorhomes & RVs",
    description: "We smog large motorhomes, RVs, and 18-wheelers — gas or diesel.",
    icon: "Caravan",
    time: "By appt."
  }
];

export const turnaround = [
  { year: "2000 & newer", time: "~20 minutes" },
  { year: "1996 – 1999", time: "~25 minutes" },
  { year: "1976 – 1995", time: "35 – 40 minutes" }
];

export const reviews = [
  {
    name: "Maria G.",
    location: "Novato, CA",
    rating: 5,
    text: "Fastest smog check I have ever had in Marin. Walked in, out in 18 minutes with paperwork already sent to the DMV. Highly recommend Hamilton's for anyone searching for smog check near me.",
    date: "2 weeks ago"
  },
  {
    name: "David R.",
    location: "San Rafael, CA",
    rating: 5,
    text: "Drove down from San Rafael on a Saturday. Friendly, honest, and price-matched a competitor without any hassle. Family-owned business you can trust.",
    date: "1 month ago"
  },
  {
    name: "Jennifer T.",
    location: "Petaluma, CA",
    rating: 5,
    text: "They smogged my 1988 Alfa Romeo on their dyno lane while I sat in the waiting area. Real experts with classic cars. Cannot say enough good things.",
    date: "1 month ago"
  },
  {
    name: "Carlos M.",
    location: "Novato, CA",
    rating: 5,
    text: "Needed a CARB heavy-duty diesel inspection for my work truck. Hamilton's was the only nearby shop equipped and they got me in the same day.",
    date: "3 weeks ago"
  },
  {
    name: "Susan L.",
    location: "Mill Valley, CA",
    rating: 5,
    text: "Two bays, two techs — no waiting. They even helped me understand what a STAR station is and why it matters for my registration. Best smog check near Novato.",
    date: "2 months ago"
  },
  {
    name: "James P.",
    location: "Sausalito, CA",
    rating: 5,
    text: "Failed my first smog check across town. Hamilton's diagnosed the issue for free, told me exactly what to fix, and passed me on the retest. Fair and knowledgeable.",
    date: "1 month ago"
  }
];

export const faqs = [
  {
    q: "How much does a smog check cost near Novato?",
    a: "Our smog check pricing is competitive with any Marin County station, and we offer a Price Match Guarantee plus $7 off when you mention our website. Final price depends on your vehicle year and type — call (415) 493-8801 for an exact quote."
  },
  {
    q: "How long does a smog check take at Hamilton's Smog?",
    a: "Most 2000-and-newer vehicles are in and out in about 20 minutes. 1996–1999 vehicles take roughly 25 minutes, and 1976–1995 classics take 35–40 minutes on our dyno lane."
  },
  {
    q: "Are you a STAR-certified smog station?",
    a: "Yes. Hamilton's Smog is a fully STAR-certified station, which means we can perform smog checks for vehicles directed by the DMV to a STAR station — required for most registration renewals in California."
  },
  {
    q: "Do I need an appointment for a smog check?",
    a: "Walk-ins are welcome and we have two bays and two technicians working simultaneously. You can also book online through our booking widget to guarantee a specific time slot."
  },
  {
    q: "What if my car fails the smog check?",
    a: "For 2000-and-newer vehicles we offer a FREE retest within 30 days. For 1976–1999 vehicles we offer a discounted retest. We will also help you understand what needs to be repaired."
  },
  {
    q: "Do you smog diesel trucks and motorhomes?",
    a: "Yes. We are equipped for heavy-duty diesel CARB periodic testing (14,000+ GVWR, 2013 and newer), as well as motorhomes, RVs, and 18-wheelers — gas or diesel."
  },
  {
    q: "What areas do you serve besides Novato?",
    a: "We proudly serve all of Marin County including San Rafael, Mill Valley, Corte Madera, Larkspur, Sausalito, Tiburon, Fairfax, San Anselmo, and Petaluma in southern Sonoma County."
  }
];

export const serviceAreas = [
  { name: "Novato", distance: "On site", zip: "94945, 94947, 94949" },
  { name: "San Rafael", distance: "~8 miles", zip: "94901, 94903" },
  { name: "Petaluma", distance: "~9 miles", zip: "94952, 94954" },
  { name: "Mill Valley", distance: "~15 miles", zip: "94941" },
  { name: "Larkspur", distance: "~12 miles", zip: "94939" },
  { name: "Corte Madera", distance: "~13 miles", zip: "94925" },
  { name: "Fairfax", distance: "~11 miles", zip: "94930" },
  { name: "San Anselmo", distance: "~10 miles", zip: "94960" },
  { name: "Sausalito", distance: "~17 miles", zip: "94965" },
  { name: "Tiburon", distance: "~16 miles", zip: "94920" },
  { name: "Ross", distance: "~11 miles", zip: "94957" },
  { name: "Kentfield", distance: "~12 miles", zip: "94904" }
];

export const tips = {
  modern: [
    "Complete a drive cycle: drive ~100 miles under mixed city and highway conditions in the days before your test.",
    "On the highway, hold a steady 55 mph for 5–10 minute intervals, repeated 3–5 times.",
    "Make sure your Check Engine light is OFF before arriving. If it is on, the car will not pass.",
    "Ask for a FREE readiness pre-check at Hamilton's before we begin the official inspection."
  ],
  classic: [
    "Get an oil change and replace the air filter and PCV valve before testing.",
    "Consider a tune-up if the last one was more than 50,000 miles ago.",
    "Keep the fuel level between 1/2 and 3/4 full — never nearly empty or completely topped off.",
    "Drive the vehicle 30–60 minutes right before your appointment so the engine and catalytic converter are hot."
  ]
};

export const stats = [
  { value: "20 min", label: "Average turnaround (2000+)" },
  { value: "2 bays", label: "Simultaneous service" },
  { value: "1000s", label: "Vehicles smogged since 2021" },
  { value: "5.0★", label: "Google review average" }
];

export const heroImage = "https://customer-assets-gfyr7b9c.emergentagent.net/job_smog-check-near-me/artifacts/1bejplve_HANDS%20UNDERHOOD.jpg";
export const aboutImage = "https://customer-assets-gfyr7b9c.emergentagent.net/job_smog-check-near-me/artifacts/2ko1p0ox_IMG_6082%20%281%29.webp";
export const bayImage = "https://customer-assets-gfyr7b9c.emergentagent.net/job_smog-check-near-me/artifacts/wpmffo0x_IMG_2145%20BOTH%20BAYS%20RIGHTSIDE.webp";
export const inspectionImage = "https://customer-assets-gfyr7b9c.emergentagent.net/job_smog-check-near-me/artifacts/3tfqz068_smog%20scanne%202.jpg";
export const classicImage = "https://images.unsplash.com/photo-1487754180451-c456f719a1fc";
export const shopImage = "https://customer-assets-gfyr7b9c.emergentagent.net/job_smog-check-near-me/artifacts/xvuv53cx_image.webp";

export const galleryImages = [
  {
    url: "https://customer-assets-gfyr7b9c.emergentagent.net/job_smog-check-near-me/artifacts/2ko1p0ox_IMG_6082%20%281%29.webp",
    caption: "Two Porsches getting smog checks — same day, same bay",
    tag: "Performance"
  },
  {
    url: "https://customer-assets-gfyr7b9c.emergentagent.net/job_smog-check-near-me/artifacts/wpmffo0x_IMG_2145%20BOTH%20BAYS%20RIGHTSIDE.webp",
    caption: "Two bays, two techs — no waiting",
    tag: "The Shop"
  },
  {
    url: "https://customer-assets-gfyr7b9c.emergentagent.net/job_smog-check-near-me/artifacts/1bejplve_HANDS%20UNDERHOOD.jpg",
    caption: "OBD-II diagnostics on a modern engine bay",
    tag: "Certified"
  },
  {
    url: "https://customer-assets-gfyr7b9c.emergentagent.net/job_smog-check-near-me/artifacts/3tfqz068_smog%20scanne%202.jpg",
    caption: "Fast, accurate smog inspections — PASS on the first try",
    tag: "Fast Service"
  }
];
